import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Home from './pages/Home';
import MovieDetails from './pages/MovieDetails';
import Browse from './pages/Browse';
import Search from './pages/Search';
import Past from './pages/Past';
import Present from './pages/Present';
import Future from './pages/Future';
import Navigation from './components/Navigation';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App min-h-screen bg-cinema-black">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/movie/:id" element={<MovieDetails />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/search" element={<Search />} />
          <Route path="/past" element={<Past />} />
          <Route path="/present" element={<Present />} />
          <Route path="/future" element={<Future />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;